var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 390.45 390.45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-g-1{fill:#1461dc;}.cls-g-2{fill:#4191ef;}.cls-g-3,.cls-g-4,.cls-g-6{isolation:isolate;}.cls-g-3{fill:url(#linear-gradient-g);}.cls-g-4{fill:url(#linear-gradient-g-2);}.cls-g-5{fill:url(#linear-gradient-g-3);}.cls-g-6{fill:url(#linear-gradient-g-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-g",
    x1: 353.62,
    x2: 136.87,
    y1: 376.59,
    y2: -0.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2f2f2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccc",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-g-2",
    x1: 251.5,
    x2: 35.27,
    y1: 12.02,
    y2: 406.49,
    xlinkHref: "#linear-gradient-g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-g-3",
    x1: 134.61,
    x2: 147.49,
    y1: 199.13,
    y2: 199.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082fb",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064e0",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-g-4",
    x2: 398.62,
    y1: 331.5,
    y2: 331.5,
    xlinkHref: "#linear-gradient-g"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-g-1",
    points: "181.95 304.27 181.82 304.3 181.82 304.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-g-2",
    d: "M182,304.27c-.1.07-11.93.05-12.06.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-g-3",
    d: "m390.45 314.31a81.13 81.13 0 0 1-17.3 50.23 66.79 66.79 0 0 1-55.78 25.82c15.45-46.73-10.54-82.71-28.55-118-9.54-15.81-36.69-73.06-47.84-86.15-9.89-12.33-24-19.13-38.79-20.7-20-4.25-41.52 4.23-54.3 20.07 29.51-53.88 61.75-115 90.87-168.85 8.48 7 15.45 18.53 20.7 29.28l121.59 230.49a80.45 80.45 0 0 1 9.4 37.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-g-4",
    d: "M193.67,304.19l-59.89,0c-35.23,0-72.35,4.13-98.09-10.66l-.1-.07a43.26,43.26,0,0,1-4.81-3.21,79.82,79.82,0,0,1-19.56-17.65h0C45.25,208.11,96.33,111.31,130.78,46c6.81-14.28,15.93-27.37,28.44-35.24h0c24.27-16.29,57.55-14,79.52,6-28.5,53.06-61.74,115-90.21,168-.23.28-.45.57-.68.86h0a5.67,5.67,0,0,0-.39.5C113.71,228.87,137,303.28,193.67,304.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-g-5",
    d: "m147.49 186.11a76.87 76.87 0 0 0-12.88 26 66.09 66.09 0 0 1 12.88-26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-g-6",
    d: "m317.36 390.36c-62.88-0.17-185.39-0.38-248.24-0.53-55.08 1.11-87.54-69.7-57.9-117.2a79.82 79.82 0 0 0 19.56 17.65 43.26 43.26 0 0 0 4.81 3.21l0.1 0.07c25.74 14.79 62.86 10.66 98.09 10.66h59.89c3.16 0.06 106.26 0 112.05 0a172.35 172.35 0 0 1 12 29.39c5.52 17.7 6 38.72-0.36 56.75z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGray);
export default __webpack_public_path__ + "static/media/LogoGray.db76d40e.svg";
export { ForwardRef as ReactComponent };